(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var CONST_FILE_BASE = commonFunc.getProperties().constFileBase;
var labels = commonFunc.getLabel();
var HeaderLoginBox = React.createClass({
  displayName: "HeaderLoginBox",
  render: function render() {
    return /*#__PURE__*/React.createElement("header", {
      className: "tnHeader -md"
    }, /*#__PURE__*/React.createElement("div", {
      className: "tnHeader__catch"
    }, /*#__PURE__*/React.createElement("img", {
      src: "./" + CONST_FILE_BASE + "img/common/img_header.png",
      alt: "To Be a Good Company"
    })), /*#__PURE__*/React.createElement("div", {
      className: "tnHeader__content"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "tnHeader__logo"
    }, /*#__PURE__*/React.createElement("a", {
      href: "index.html"
    }, /*#__PURE__*/React.createElement("img", {
      src: "./" + CONST_FILE_BASE + "img/common/logo_header.svg",
      alt: "\u6771\u4EAC\u6D77\u4E0A\u30B9\u30DE\u30FC\u30C8\u30E2\u30D3\u30EA\u30C6\u30A3",
      className: "-logo"
    }), /*#__PURE__*/React.createElement("img", {
      src: "./" + CONST_FILE_BASE + "img/common/logo_header2.svg",
      alt: "WeDrive",
      className: "-logo2"
    }))), /*#__PURE__*/React.createElement("nav", {
      className: "tnNav -md"
    })));
  }
});
module.exports = HeaderLoginBox;

},{}],2:[function(require,module,exports){
'use strict';

var userColorProperties = require('./util/userColorProperties.js');
var HeaderLoginBox = require('./include/login/header-login.jsx');

//ログイン画面
var LoginBox = React.createClass({
  displayName: "LoginBox",
  //初期引数
  getDefaultProps: function getDefaultProps() {
    return {
      constPage: commonFunc.getProperties().constLogin,
      constMessage: commonFunc.getProperties().constMessage,
      constHeader: commonFunc.getProperties().constHeader
    };
  },
  //初期ステート
  getInitialState: function getInitialState() {
    var userId = commonFunc.getWebStorage('userId', true);

    //パースできなければ空文字
    try {
      userId = JSON.parse(userId);
    } catch (err) {
      userId = '';
    }
    return {
      userId: userId,
      password: '',
      errorMsg: '',
      isPasswordVisible: false
    };
  },
  getMessage: function getMessage(key, msg) {
    var msgArray;
    if ($.isArray(msg)) {
      msgArray = msg;
    } else {
      msgArray = [msg];
    }
    var returnMsg = commonFunc.getProperties().constMessage[key];
    if (!returnMsg && returnMsg == null) {
      return '';
    } else {
      // &[要素番号+1]の文字を置換 「&1」の置換で「&10」が置換されないよう、末尾から置換
      for (var i = msgArray.length; i > 0; i--) {
        if (msgArray[i - 1] !== 'undefined') {
          returnMsg = returnMsg.replace('&' + i, msgArray[i - 1]);
        }
      }
      return returnMsg;
    }
  },
  // パスワード入力の表示/非表示を切り替える
  togglePasswordVisibility: function togglePasswordVisibility() {
    this.setState(function (prevState) {
      return {
        isPasswordVisible: !prevState.isPasswordVisible
      };
    });
  },
  // 表示切り替えボタンでフォーカスが移らないようにする
  handlePasswordToggleMouseDown: function handlePasswordToggleMouseDown(event) {
    event.preventDefault();
  },
  //コンポーネント読み込み前
  componentWillMount: function componentWillMount() {
    // google analytics
    window.dataLayer = window.dataLayer || [];
    dataLayer.push('config', commonFunc.getProperties().googleTag, 'auto');
    dataLayer.push({
      'event': 'pageview',
      'page_location': '/login/login',
      'page_title': 'ログイン/ログイン'
    });

    //デザイン指定
    userColorProperties.userColorProperties('0');
  },
  //コンポーネント読込後
  componentDidMount: function componentDidMount() {
    //デザイン指定
    userColorProperties.userColorProperties('0');
    //タイトル設定
    $('title').text(this.props.constPage.TITLE);

    //画面設定
    fixHeight();
    initLogin();
    panelScrollBar();

    //ストレージからログイン情報を削除
    var removeLoginInfo = function removeLoginInfo() {
      commonFunc.removeWebStorage('jwtToken');
      commonFunc.removeWebStorage('userData');
      commonFunc.removeWebStorage('logout');
      commonFunc.removeWebStorage('timeout');
      commonFunc.removeWebStorage('direct');
    };
    if (commonFunc.getWebStorage('logout') == '1') {
      removeLoginInfo();
    } else if (commonFunc.getWebStorage('timeout') == '1') {
      removeLoginInfo();
      commonFunc.alertError(this.getMessage('TIMEOUT_ERR'));
    } else if (commonFunc.getWebStorage('direct') == '1') {
      removeLoginInfo();
      commonFunc.alertError(this.getMessage('DIRECT_ERR'));
    } else {}

    //バリデーション定義
    $('#main-form').validate({
      errorClass: 'error',
      errorElement: 'span',
      highlight: function highlight(element, errorClass, validClass) {
        $(element).parents("div[class='control-group']").addClass(errorClass);
      },
      unhighlight: function unhighlight(element, errorClass, validClass) {
        $(element).parents('.error').removeClass(errorClass);
      },
      rules: {
        userId: {
          required: true
        },
        password: {
          required: true
        }
      },
      messages: {
        userId: this.getMessage('ALERT_REQUIRED', this.props.constPage.TX_USERID),
        password: this.getMessage('ALERT_REQUIRED', this.props.constPage.TX_PASSWORD)
      },
      tooltip_options: {
        userId: {
          placement: 'bottom'
        },
        password: {
          placement: 'bottom'
        }
      }
    });

    // 戻る遷移で復帰した際にもフラグを初期化
    window.addEventListener('pageshow', this.resetLoginFlag);
  },
  // リスナーを解除しないと復帰時に二重登録されるためクリーンアップ
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener('pageshow', this.resetLoginFlag);
  },
  // API成功後の遷移やブラウザバック完了時に連打フラグを戻す
  resetLoginFlag: function resetLoginFlag() {
    this.loginflg = true;
  },
  onClickloginInfo: function onClickloginInfo() {
    var title = this.props.constPage.MSG_LOGIN_INFO_TITLE;
    var message = "\n        ".concat(this.props.constPage.MSG_LOGIN_INFO1, "\n        ").concat(this.props.constPage.MSG_LOGIN_INFO2, "\n        ").concat(this.props.constPage.MSG_LOGIN_INFO3, "\n        ");
    commonFunc.alertLoginInfo(title, message);
  },
  //利用者ID変更時
  onChangeUserId: function onChangeUserId(e) {
    var val = e.target.value;
    this.setState({
      userId: val
    });
  },
  //パスワード変更時
  onChangePassword: function onChangePassword(e) {
    var val = e.target.value;
    this.setState({
      password: val
    });
  },
  //パスワード内キー押下時
  onKeyDownPassword: function onKeyDownPassword(e) {
    var val = e.target.value;
    //パスワード項目でエンターを押すとログイン処理
    if (e.keyCode == 13) {
      this.onClicklogin();
    }
  },
  //重複リクエスト防止用フラグ
  loginflg: true,
  //ログインボタンクリック時
  onClicklogin: function onClicklogin(e) {
    var _this = this;
    //画面から値を取得
    var userId = $('#userId').val();
    var password = $('#password').val();

    //バリデーション
    if ($('#main-form').valid()) {
      var parent = this;
      var url = commonFunc.getProperties().baseUrl + commonFunc.getProperties().api;
      var command = 'login';
      var requestData = {
        command: command,
        userId: userId,
        password: password
      };
      if (this.loginflg === true) {
        this.loginflg = false;
        commonFunc.postJsonRequest({
          url: url,
          data: requestData
        }).done(function (data, statusText, jqXHR) {
          // ログイン成功時
          if (data.status == '0') {
            var nextHtml = data.body.nextHtml || '';
            var isReport = nextHtml.indexOf('report.html') !== -1;
            var isMonitoring = nextHtml.indexOf('monitoring-map.html') !== -1;
            var isExistingFlow = isReport || isMonitoring;

            // 結果をストレージに格納する。
            commonFunc.setWebStorage('jwtToken', JSON.stringify(data.body.jwtToken));

            // パターン①②（電話番号登録/ワンタイムコード）は JWT のみ保存
            // パターン③（リアルタイム位置情報・日報）は従来どおり必要情報を格納
            if (isExistingFlow) {
              commonFunc.setWebStorage('userData', JSON.stringify(data.body.userData));
              commonFunc.setWebStorage('userId', JSON.stringify(userId), true);
              commonFunc.setWebStorage('googleApiKey', data.body.googleApiKey);
              commonFunc.setWebStorage('googleClientId', data.body.googleClientId);
              commonFunc.setWebStorage('lastLoginDateTime', data.body.entYmdtim);
            }

            //後続HTMLへ移動
            location.href = nextHtml;

            //ログイン失敗時
          } else if (data.errmessage) {
            // 失敗時はボタンを再度押下可能にする
            _this.resetLoginFlag();
            var smsLimitErrorMsg = commonFunc.getMessage('SMS_LIMIT_ERROR');
            if (data.errmessage === smsLimitErrorMsg) {
              // SMS送信上限のみ既存遷移＆遷移先表示
              var nextHtml = data.body.nextHtml ? data.body.nextHtml : 'oneTimePass.html';
              commonFunc.setWebStorage('oneTimePassErrorMsg', data.errmessage);
              location.href = nextHtml;
            } else {
              // それ以外はログイン画面でエラー表示
              commonFunc.alertLoginError(data.errmessage, _this.props.constPage.MSG_LINK_INFO3, _this.props.constPage.MSG_LINK_INFO2, _this.props.constPage.MSG_LINK_INFO4);
            }
          } else {
            _this.resetLoginFlag();
            //エラーメッセージの表示
            commonFunc.alertLoginError(data.errmessage, _this.props.constPage.MSG_LINK_INFO3, _this.props.constPage.MSG_LINK_INFO2, _this.props.constPage.MSG_LINK_INFO4);
          }
        }).fail(function (jqXHR, statusText, errorThrown) {
          _this.resetLoginFlag();
        });
      }
    }
  },
  //エラーメッセージの描画
  renderErrorMsg: function renderErrorMsg() {
    if (this.state.errorMsg != null && this.state.errorMsg != '') {
      return /*#__PURE__*/React.createElement("div", null, this.state.errorMsg);
    } else {
      return null;
    }
  },
  handleAppLinkClick: function handleAppLinkClick(e) {
    var isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    var isAndroid = /Android/i.test(navigator.userAgent);
    var isMac = /Macintosh/i.test(navigator.userAgent) && !isIOS;
    var isWindows = /Windows/i.test(navigator.userAgent);
    var isFocusLost = false;
    window.addEventListener('blur', function () {
      isFocusLost = true;
    });
    if (isIOS) {
      // iOSの場合
      var appUrl = 'alcoholcheckformimamodrive://dl/alcohol-check/top?v=1';
      var storeUrl = 'https://apps.apple.com/jp/app/%E3%82%A2%E3%83%AB%E3%82%B3%E3%83%BC%E3%83%AB%E6%A4%9C%E7%9F%A5%E5%99%A8%E3%81%A8%E9%80%A3%E6%90%BA%E3%82%AA%E3%83%97%E3%82%B7%E3%83%A7%E3%83%B3-mimamo-drive/id6736607362';
      window.location = appUrl;
      setTimeout(function () {
        if (!isFocusLost) {
          window.location = storeUrl;
        }
      }, 1000);
    } else if (isAndroid) {
      // Androidの場合
      var _appUrl = 'alcoholcheckformimamodrive://dl/alcohol-check/top?v=1';
      var _storeUrl = 'https://play.google.com/store/apps/details?id=jp.co.tokiomarine_smartmobility.alcoholcheck_for_mimamodrive';
      window.location = _appUrl;
      setTimeout(function () {
        if (!isFocusLost) {
          window.location = _storeUrl;
        }
      }, 1000);
    } else if (isMac) {
      // MacOSの場合 (App Storeへ誘導)
      var _storeUrl2 = 'https://apps.apple.com/jp/app/%E3%82%A2%E3%83%AB%E3%82%B3%E3%83%BC%E3%83%AB%E6%A4%9C%E7%9F%A5%E5%99%A8%E3%81%A8%E9%80%A3%E6%90%BA%E3%82%AA%E3%83%97%E3%82%B7%E3%83%A7%E3%83%B3-mimamo-drive/id6736607362';
      window.location = _storeUrl2;
    } else if (isWindows) {
      // Windowsの場合 (Google Playストアへ誘導)
      var _storeUrl3 = 'https://play.google.com/store/apps/details?id=jp.co.tokiomarine_smartmobility.alcoholcheck_for_mimamodrive';
      window.location = _storeUrl3;
    } else {
      // それ以外のOSの場合
      window.location = 'https://www.tokiomarine-smartmobility.co.jp/service/mimamodrive/index.html';
    }
  },
  render: function render() {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HeaderLoginBox, null), this.renderErrorMsg(), /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement("img", {
      src: './' + commonFunc.getProperties().constFileBase + 'img/login/logo-login.svg',
      alt: "MIMAMO DRIVE",
      className: "newLogin__logo"
    })), /*#__PURE__*/React.createElement("div", {
      className: "newLogin__form"
    }, /*#__PURE__*/React.createElement("form", {
      id: "main-form"
    }, /*#__PURE__*/React.createElement("div", {
      className: "newLogin__text"
    }, this.props.constPage.LABEL_LOGIN_DESCRIPTION), /*#__PURE__*/React.createElement("div", {
      className: "newLogin__text newLogin__text__small"
    }, this.props.constPage.MSG_LINK_INFO1, /*#__PURE__*/React.createElement("a", {
      href: "authentication.html"
    }, this.props.constPage.MSG_LINK_INFO2)), /*#__PURE__*/React.createElement("input", {
      type: "text",
      id: "userId",
      name: "userId",
      lang: "en",
      pattern: "[A-Za-z0-9]+",
      className: "validate[required] text-input",
      placeholder: this.props.constPage.TX_USERID,
      value: this.state.userId,
      onChange: this.onChangeUserId
    }), /*#__PURE__*/React.createElement("div", {
      className: "newLogin__password-field"
    }, /*#__PURE__*/React.createElement("input", {
      type: this.state.isPasswordVisible ? 'text' : 'password',
      id: "password",
      name: "password",
      lang: "en",
      pattern: "[A-Za-z0-9]+",
      className: "validate[required] text-input",
      placeholder: this.props.constPage.TX_PASSWORD,
      value: this.state.password,
      onChange: this.onChangePassword,
      onKeyDown: this.onKeyDownPassword
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "newLogin__password-toggle",
      onClick: this.togglePasswordVisibility,
      onMouseDown: this.handlePasswordToggleMouseDown,
      "aria-pressed": this.state.isPasswordVisible
    }, this.state.isPasswordVisible ? '非表示' : '表示')), /*#__PURE__*/React.createElement("div", {
      className: "login-error-area"
    }, /*#__PURE__*/React.createElement("p", {
      className: "login-error-message"
    }, this.props.constPage.MSG_LINK_INFO3, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
      href: "authentication.html"
    }, this.props.constPage.MSG_LINK_INFO2), this.props.constPage.MSG_LINK_INFO4)), /*#__PURE__*/React.createElement("div", {
      className: "login-form-submit"
    }, /*#__PURE__*/React.createElement("input", {
      type: "button",
      className: "newLogin__form__submit",
      value: this.props.constPage.LOGIN,
      onClick: this.onClicklogin
    })))), /*#__PURE__*/React.createElement("div", {
      type: "button",
      className: "newLogin__info__link",
      onClick: this.onClickloginInfo
    }, this.props.constPage.LABEL_LOGIN_INFO), /*#__PURE__*/React.createElement("div", {
      className: "newLogin__lower"
    }, /*#__PURE__*/React.createElement("div", {
      className: "newLogin__text"
    }, this.props.constPage.LABEL_AUTHENTICATION), /*#__PURE__*/React.createElement("a", {
      type: "button",
      className: "newLogin__link",
      href: "authentication.html"
    }, this.props.constPage.BTN_AUTHENTICATION), /*#__PURE__*/React.createElement("div", {
      className: "newLogin__text"
    }, this.props.constPage.LABEL_CONFIRMPASS), /*#__PURE__*/React.createElement("a", {
      type: "button",
      className: "newLogin__link2",
      href: "confirmPassword.html"
    }, this.props.constPage.BTN_CONFIRMPASS), /*#__PURE__*/React.createElement("div", {
      id: "loginInfo",
      className: "disp__none"
    }, /*#__PURE__*/React.createElement("div", {
      className: "loginInfo__title"
    }, this.props.constPage.MSG_LOGIN_INFO_TITLE), /*#__PURE__*/React.createElement("div", {
      className: "loginInfo__text"
    }, this.props.constPage.MSG_LOGIN_INFO1, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), this.props.constPage.MSG_LOGIN_INFO2, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), this.props.constPage.MSG_LOGIN_INFO3, /*#__PURE__*/React.createElement("br", null)))), /*#__PURE__*/React.createElement("div", {
      className: "newLogin__alc"
    }, /*#__PURE__*/React.createElement("div", {
      className: "newLogin__alc__link"
    }, /*#__PURE__*/React.createElement("input", {
      type: "button",
      className: "newLogin__alc__link",
      value: "".concat(this.props.constPage.LABEL_LOGIN_ALC),
      onClick: this.handleAppLinkClick
    })), /*#__PURE__*/React.createElement("div", {
      className: "newLogin__alc__text"
    }, "\u203B\u7D50\u679C\u306F\u65E5\u5831\u306B\u53CD\u6620\u3055\u308C\u307E\u305B\u3093")), /*#__PURE__*/React.createElement("div", {
      className: "newLogin__lower"
    }, /*#__PURE__*/React.createElement("div", {
      className: "newLogin__copyright"
    }, "Copyright (c) Tokio Marine Smart Mobility Co., Ltd.")));
  }
});
$(function () {
  ReactDOM.render( /*#__PURE__*/React.createElement(LoginBox, null), $('#login-body')[0]);
});

},{"./include/login/header-login.jsx":1,"./util/userColorProperties.js":3}],3:[function(require,module,exports){
"use strict";

/**
 * ユーザー設定の文字色変更用js
 */
module.exports = {
  userColorProperties: function userColorProperties(type) {
    var body = document.getElementsByTagName("body")[0];
    if (type == '1') {
      body.style.fontWeight = 300;
    } else if (type == '2') {
      body.style.fontWeight = 500;
    } else if (type == '3') {
      body.style.fontWeight = 700;
    } else {
      //画面遷移時の呼び出し(type:0)
      //webstorage上の選択を取得する
      var userSelectColorType = commonFunc.getWebStorage('userSelectColorType', true);
      if (userSelectColorType == '2') {
        body.style.fontWeight = 500;
      } else if (userSelectColorType == '1') {
        body.style.fontWeight = 300;
      } else {
        body.style.fontWeight = 700;
      }
    }
  }
};

},{}]},{},[2]);
